module.exports = __webpack_public_path__ + "static/media/Fibbotool.3f392cad.svg";